import styled from 'styled-components';
import {motion} from 'framer-motion';

const ModalOverlay = styled(motion.div)`
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 9688;
    background-color: rgba(4, 4, 6, 0.62);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
`;

export const Styled = {
    ModalOverlay,
};
